import _ from 'lodash'

const sanitizeData = (data, allowedParams) => ({
  ..._.pick(data, allowedParams)
})

export default sanitizeData
